/**
 * GZ#4154 / knowhow #749 (GZ#3906) — Open Match Level Range defaults.
 *
 * Flutter `formatOpenMatchLevelRange` hides unrestricted sentinels
 * (null, 0–0, or min<=-10 && max>=10). Admin create used to default the
 * dropdowns to 1–3, so every new Open Match wrote Level 1.0–3.0 onto
 * share previews even when Services had no restriction.
 *
 * Fresh bookings write 0/0. Loaded bookings keep a real stored range
 * (including an intentional 1–3).
 */

export const OPEN_MATCH_DEFAULT_MIN_LEVEL = "0";
export const OPEN_MATCH_DEFAULT_MAX_LEVEL = "0";

export type OpenMatchLevelFormValues = {
  min_level: string;
  max_level: string;
};

export const OPEN_MATCH_LEVEL_FORM_DEFAULTS: OpenMatchLevelFormValues = {
  min_level: OPEN_MATCH_DEFAULT_MIN_LEVEL,
  max_level: OPEN_MATCH_DEFAULT_MAX_LEVEL,
};

/** Values written on create/update from the booking-modal form fields. */
export function openMatchLevelPayload(
  minLevel: string,
  maxLevel: string
): { min_level: number; max_level: number } {
  return {
    min_level: Number(minLevel),
    max_level: Number(maxLevel),
  };
}

/** Hydrate Match Settings from stored openMatchOptions. Real 1–3 stays. */
export function openMatchLevelFormFromOptions(options?: {
  min_level?: unknown;
  max_level?: unknown;
} | null): OpenMatchLevelFormValues {
  return {
    min_level:
      options?.min_level != null
        ? Number(options.min_level).toFixed(1)
        : OPEN_MATCH_DEFAULT_MIN_LEVEL,
    max_level:
      options?.max_level != null
        ? Number(options.max_level).toFixed(1)
        : OPEN_MATCH_DEFAULT_MAX_LEVEL,
  };
}
